import { BroadcastLiveWebinar } from '@live-webinar/broadcast';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/b/$linkCode'].update({
        staticData: { title: { webinar: 'Title.BroadcastWebinar' } },
        component: BroadcastLiveWebinar
    });
};
